
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Nearestpicnicspotinnagpur() {



  const cardData =
  {
    keyword: ' Nearest Picnic Spot in Nagpur',
    heading:  'Woodland Escape: Nearest Picnic Spot in Nagpur',
    headingDescription: 'Nearest Picnic Spot in Nagpur Woodland Escape Resort offers a peaceful retreat just minutes away from the city, surrounded by tall trees, open lawns, and soothing countryside vibes. Designed for families and nature lovers, the resort provides a perfect blend of comfort and tranquility within easy reach of Nagpur. Guests can relax amidst greenery, enjoy spacious picnic lawns, and experience the calm ambience that refreshes the mind and body. Whether it’s a family get-together, a weekend outing, or a short escape from daily life, Woodland Escape Resort near Nagpur ensures a rejuvenating experience close to nature',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "Nearest Picnic Spot in Nagpur",
      "description": "Woodland Escape Resort is one of the nearest picnic spots in Nagpur, just a short drive from the city. Surrounded by serene greenery and calm natural landscapes, it’s perfect for a quick escape with family or friends. Enjoy outdoor games, relaxing walks, and tasty meals while soaking in the peaceful countryside environment."
    },
    {
      "name": "Closest Picnic Place Nagpur",
      "description": "Looking for the closest picnic place near Nagpur? Woodland Escape Resort offers a convenient location where nature and comfort meet. Visitors can enjoy picnic setups under shady trees, open lawns for group games, and relaxing views of the surrounding hills. Ideal for spontaneous day trips without long travel time."
    },
    {
      "name": "Nagpur Nearby Picnic Locations",
      "description": "Among the nearby picnic locations from Nagpur, Woodland Escape Resort stands out for its natural charm and family-friendly amenities. Guests can enjoy open-air dining, guided nature walks, and refreshing outdoor experiences. The resort’s proximity to the city makes it a go-to destination for quick weekend getaways."
    },
    {
      "name": "Nagpur Local Picnic Spot",
      "description": "Woodland Escape Resort is a favorite local picnic spot for Nagpur residents. The resort offers large picnic lawns, shaded sitting areas, and various activities like cycling, farm walks, and traditional outdoor games. It’s the perfect destination for those who want to spend quality time outdoors without traveling far."
    },
    {
      "name": "Nagpur Weekend Picnic Near Me",
      "description": "Searching for a weekend picnic near Nagpur? Woodland Escape Resort is the perfect nearby getaway for families, friends, and corporate groups. With outdoor sports, nature trails, and delicious food, it’s designed for both relaxation and fun. The peaceful setting ensures a refreshing weekend retreat close to home."
    },
    {
      "name": "Nagpur Park Picnic Near Me",
      "description": "If you love park-style picnics, Woodland Escape Resort offers that and more. Located close to Nagpur, it features lush gardens, playgrounds, and shaded areas for a comfortable outdoor experience. Guests can enjoy picnic meals, stroll through green paths, and unwind in a private, peaceful atmosphere."
    },
    {
      "name": "Affordable Picnic Spot Nagpur",
      "description": "Woodland Escape Resort is one of the most affordable picnic spots near Nagpur. Families and groups can enjoy a full day of fun with budget-friendly packages that include meals, games, and access to the resort’s natural attractions. It’s an excellent choice for those looking for an enjoyable outing without overspending."
    },
    {
      "name": "Nagpur Scenic Picnic Spot",
      "description": "With picturesque views and a tranquil ambiance, Woodland Escape Resort is a scenic picnic spot near Nagpur. The lush greenery, open skies, and scenic landscapes make it an ideal setting for nature photography and outdoor relaxation. Enjoy a meal surrounded by natural beauty and fresh countryside air."
    },
    {
      "name": "Nagpur Garden Picnic Spot",
      "description": "Woodland Escape Resort offers a beautiful garden picnic experience near Nagpur, featuring colorful flowers, shady trees, and open lawns. Visitors can spread picnic mats, enjoy local cuisine, and relax with family in a soothing, nature-filled environment. It’s perfect for peaceful and rejuvenating family picnics."
    },
    {
      "name": "Nagpur Riverside Picnic Spot",
      "description": "For a refreshing riverside picnic near Nagpur, Woodland Escape Resort provides a serene escape beside calm waters and lush greenery. Guests can enjoy picnics by the riverside, play outdoor games, and take part in short nature walks. The soothing environment is perfect for unwinding and reconnecting with nature."
    },
    {
      "name": "Nagpur Hill Picnic Spot",
      "description": "Located near Nagpur’s scenic highlands, Woodland Escape Resort offers a hill picnic experience with panoramic views and fresh mountain air. Guests can explore short hiking trails, enjoy open-air meals, and relax amidst natural beauty. It’s an ideal location for couples, groups, and families seeking a scenic outdoor day."
    },
    {
      "name": "Nagpur Family Picnic Nearby",
      "description": "Woodland Escape Resort is the perfect nearby family picnic spot near Nagpur, providing a fun, safe, and comfortable setting for all ages. Kids can play in open areas, while adults relax in the resort’s scenic surroundings. Enjoy wholesome food, family games, and plenty of space to unwind together."
    },
    {
      "name": "Nagpur Short Trip Picnic Spot",
      "description": "For a short trip from Nagpur, Woodland Escape Resort is an ideal picnic spot. Just a quick drive away, it offers everything you need for a memorable outing — from outdoor activities and nature walks to delicious meals and relaxation zones. Spend a few hours in nature and return refreshed."
    },
    {
      "name": "Nagpur One Day Picnic Tour",
      "description": "Plan a one-day picnic tour from Nagpur to Woodland Escape Resort and make your day extraordinary. The tour includes meals, outdoor fun, and relaxation in the lap of nature. Perfect for schools, families, or corporate groups looking for a balanced mix of recreation and rest close to the city."
    },
    {
      "name": "Nagpur Picnic Spot Booking",
      "description": "Easily book your picnic day at Woodland Escape Resort near Nagpur. The resort offers flexible packages for groups, families, and corporate outings that include meals, guided activities, and exclusive access to picnic areas. Advance booking ensures smooth arrangements and a hassle-free experience."
    }
  ],
  "tableData": [
    ["- Nearest Picnic Spot in Nagpur", "- Closest Picnic Place Nagpur"],
    ["- Nagpur Nearby Picnic Locations", "- Nagpur Local Picnic Spot"],
    ["- Nagpur Weekend Picnic Near Me", "- Nagpur Park Picnic Near Me"],
    ["- Affordable Picnic Spot Nagpur", "- Nagpur Scenic Picnic Spot"],
    ["- Nagpur Garden Picnic Spot", "- Nagpur Riverside Picnic Spot"],
    ["- Nagpur Hill Picnic Spot", "- Nagpur Family Picnic Nearby"],
    ["- Nagpur Short Trip Picnic Spot", "- Nagpur One Day Picnic Tour"],
    ["- Nagpur Picnic Spot Booking", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Nearest Picnic Spot in Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is one of the nearest and most scenic picnic spots from Nagpur. Just a short drive away, it offers the perfect balance of convenience and natural beauty. Surrounded by dense forest and refreshing greenery, it’s an ideal destination for families, friends, and nature lovers looking for a quick yet memorable outdoor getaway."
  },
  {
    "WhyChooseheading": "Close-to-City Yet Surrounded by Nature",
    "WhyChoosedescription": "Even though it’s located near Nagpur, Woodland Escape Resort feels like a world away from the city’s hustle. The peaceful forest setting, clean air, and soothing natural sounds create an atmosphere where visitors can relax and rejuvenate without traveling far. It’s the perfect escape that’s conveniently close to home."
  },
  {
    "WhyChooseheading": "Ideal for Day Trips and Picnics",
    "WhyChoosedescription": "Whether you’re planning a spontaneous outing or a well-planned family picnic, Woodland Escape Resort offers the perfect setup. With comfortable seating zones, shaded picnic areas, and open lawns, guests can enjoy quality time outdoors while surrounded by the forest’s serene charm."
  },
  {
    "WhyChooseheading": "Fun Activities for Everyone",
    "WhyChoosedescription": "Enjoy a wide range of activities suited for all ages — from forest walks, cycling, and adventure games to bird watching and pondside relaxation. Woodland Escape Resort ensures that your visit is filled with both excitement and tranquility, making it one of the most enjoyable picnic destinations near Nagpur."
  },
  {
    "WhyChooseheading": "Delicious and Fresh Local Cuisine",
    "WhyChoosedescription": "Savor freshly cooked, homestyle meals made from organic and locally sourced ingredients. Our on-site kitchen serves a variety of regional delicacies and picnic-friendly dishes that perfectly complement your outdoor experience. Every bite adds to the wholesome joy of your nature escape."
  },
  {
    "WhyChooseheading": "Perfect for Families and Friends",
    "WhyChoosedescription": "Woodland Escape Resort is designed to welcome families, friends, and groups who wish to spend a joyful day together. With wide open spaces, clean facilities, and a relaxed environment, it’s a place where everyone can connect, unwind, and enjoy a memorable day surrounded by nature."
  },
  {
    "WhyChooseheading": "Easily Accessible Location",
    "WhyChoosedescription": "Located conveniently near Nagpur, Woodland Escape Resort is easily accessible by road, making it one of the most convenient picnic spots for city residents. The short, scenic drive through natural landscapes ensures your getaway begins the moment you leave the city behind."
  }
]




  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort known as the nearest picnic spot in Nagpur?",
    answer: "Woodland Escape Resort is located just a short drive away from Nagpur, surrounded by serene greenery and natural beauty. It’s the perfect nearby destination for those who want to enjoy a relaxing picnic without traveling too far from the city."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is approximately 40–45 km from Nagpur, which takes about 1 to 1.5 hours by car. Its convenient location makes it one of the most accessible and nearest picnic spots for city residents."
  },
  {
    question: "What makes Woodland Escape Resort ideal for a quick picnic?",
    answer: "The resort offers everything you need for a refreshing break — open lawns, shaded picnic areas, boating, outdoor games, and delicious homemade food. It’s perfect for a short yet memorable outing with friends or family."
  },
  {
    question: "Do you provide meals and refreshments for picnickers?",
    answer: "Yes! Our picnic packages include welcome drinks, lunch, and evening tea with snacks. All meals are freshly prepared using locally sourced ingredients to ensure great taste and quality."
  },
  {
    question: "Is Woodland Escape Resort suitable for both small and large groups?",
    answer: "Absolutely! Whether you’re visiting with family, friends, or colleagues, our spacious picnic areas and customized group packages ensure a fun and comfortable experience for everyone."
  },
  {
    question: "How can we plan or book our picnic at Woodland Escape Resort?",
    answer: "Booking is simple — you can call or WhatsApp our reservation team, or visit our official website to make a booking online. We recommend reserving in advance, especially during weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Ramesh & Family, Nagpur",
    text: "Woodland Escape Resort is truly the nearest and best picnic spot in Nagpur! The atmosphere is calm, the staff is welcoming, and the food was delicious. We had a great family day and will definitely visit again."
  },
  {
    name: "Miss. Pooja & Friends, Nagpur",
    text: "We wanted a quick escape from the city, and Woodland Escape Resort was perfect! The drive was short, the scenery was beautiful, and the activities kept everyone entertained. Highly recommended for a nearby picnic!"
  }
];



      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Nearest Picnic Spot in Nagpur",
  "image": "https://woodlandescape.com/assets/images/nearest-picnic-spot-in-nagpur.jpg",
  "description": "Looking for the nearest picnic spot in Nagpur? Visit Woodlandescape Resort — a serene nature getaway offering fun activities, lush greenery, and peaceful surroundings for families, couples, and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "987"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1099",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nearest-picnic-spot-in-nagpur"
  }
};




  return (
    <div>
<Helmet>
  <title>Nearest Picnic Spot in Nagpur | Nature & Family Getaway | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Explore the nearest picnic spot in Nagpur at Woodlandescape Resort. Enjoy nature walks, outdoor games, and a relaxing environment perfect for families, couples, and corporate groups. Book your picnic today!" 
  />
  <meta 
    name="keywords" 
    content="Nearest Picnic Spot in Nagpur, Closest Picnic Place Nagpur, Nagpur Nearby Picnic Locations, Nagpur Local Picnic Spot, Nagpur Weekend Picnic Near Me, Nagpur Park Picnic Near Me, Affordable Picnic Spot Nagpur, Nagpur Scenic Picnic Spot, Nagpur Garden Picnic Spot, Nagpur Riverside Picnic Spot, Nagpur Hill Picnic Spot, Nagpur Family Picnic Nearby, Nagpur Short Trip Picnic Spot, Nagpur One Day Picnic Tour, Nagpur Picnic Spot Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/4.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Nearestpicnicspotinnagpur;